module.exports = __webpack_public_path__ + "static/img/icon_refresh.dc200f78.svg";